import React from 'react';
import Icon from '../../../components/AppIcon';

interface IndustryHeroProps {
  title: string;
  description: string;
  stats: {
    label: string;
    value: string;
    icon: string;
  }[];
}

const IndustryHero: React.FC<IndustryHeroProps> = ({ title, description, stats }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-16 lg:py-24">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto mb-12">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-text-primary mb-6 leading-tight">
            {title}
          </h1>
          <p className="text-lg lg:text-xl text-text-secondary leading-relaxed">
            {description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-card rounded-lg p-6 lg:p-8 shadow-md border border-border hover:shadow-lg transition-shadow duration-fast"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-lg mb-4">
                <Icon name={stat.icon} size={24} color="var(--color-primary)" />
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-primary mb-2">
                {stat.value}
              </div>
              <div className="text-sm lg:text-base text-text-secondary">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryHero;